import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  sendRequest as resendConfirmToken,
  selectRequestState
} from 'mt-react-common/modules/users/common/reducers/forms/resendConfirmTokenAction';
import OpacityPreLoader from '../../../../Common/PreLoaders/OpacityPreLoader';

const resendEmailConfirmTokenActionRN =
  'usersModule.forms.resendEmailConfirmTokenAction';

class FirstEmailConfirmNoticeBlock extends Component {
  handleResendConfirmToken = e => {
    e.preventDefault();
    this.props.resendConfirmToken();
  };

  render() {
    if (this.props.authAccountData.emailConfirm === 0) {
      return (
        <div>
          <article className="panel panel-success">
            <div className="panel-heading text-center">
              <h3 className="panel-title">{t('Подтверждение почты')}</h3>
            </div>
            <div className="panel-body text-center">
              {this.props.requestState.hasInProgress ? (
                <OpacityPreLoader />
              ) : null}
              <p>
                {t(
                  'Поздравляем с успешной регистрацией, осталось совсем чуть-чуть! \n' +
                    '<br />\n' +
                    'Для подтверждения электронной почты нажмите кнопочку ниже и\n' +
                    'перейдите по ссылке из письма'
                )}
              </p>
              <a
                href={null}
                onClick={this.handleResendConfirmToken}
                className="btn btn-block btn-default btn-muted"
                id="send_confirm_email"
              >
                {t('Подтвердить электронную почту')}
              </a>
            </div>
          </article>
        </div>
      );
    }
    return null;
  }
}

FirstEmailConfirmNoticeBlock.propTypes = {
  // IN
  authAccountData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    emailConfirm: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  resendConfirmToken: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, resendEmailConfirmTokenActionRN)
});

const mapDispatchToProps = dispatch => ({
  resendConfirmToken: () =>
    dispatch(resendConfirmToken(resendEmailConfirmTokenActionRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FirstEmailConfirmNoticeBlock);



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/FirstEmailConfirmNoticeBlock/FirstEmailConfirmDefaultNoticeBlock.js